var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2563_10564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.625 5.61653V13.7297C11.625 14.0607 11.5065 14.3782 11.2955 14.6123C11.0845 14.8463 10.7984 14.9778 10.5 14.9778H3.75C3.45163 14.9778 3.16548 14.8463 2.9545 14.6123C2.74353 14.3782 2.625 14.0607 2.625 13.7297V5.61653H1.5V4.36835H12.75V5.61653H11.625ZM3.75 5.61653V13.7297H10.5V5.61653H3.75ZM6.5625 6.8647H7.6875V8.11288H6.5625V6.8647ZM6.5625 8.73696H7.6875V9.98514H6.5625V8.73696ZM6.5625 10.6092H7.6875V11.8574H6.5625V10.6092ZM4.3125 2.49609H9.9375V3.74427H4.3125V2.49609Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6.65625,
    width: 2.25,
    height: 5.82481,
    fill: "#171717"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2563_10564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 14.9781,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.6ccdff04a7028679fc06b731f5d081b0.svg";
export { ForwardRef as ReactComponent };